export default {
  noDumps: 'No dumps available. Generate a new dump?',
  metricsDisabled: 'Engine\'s metrics are disabled',
  generateDump: 'Generate a new dump',
  downloadDump: 'Download dump',
  enabled: 'Tech metrics enabled',
};
